export default __webpack_public_path__ + "static/aerial_hero-4ef50f53c09a360462548660b739ffe7.jpg";